var booted = false;
var context = {
  analytics: {},
  browser: {},
  content: {},
  ecommerce: {},
  user: {}
};

var getContentFromMetaTag = function (name) {
  var meta = document.querySelector(`meta[name="${name}"]`);
  return meta ? meta.getAttribute('content') : '';
};

var fillAnalytics = function () {
  context.analytics = {
    comscore: {
      advertisement_blocker: window.voc_adb,
      content: {
        author:            window.voc_au,
        language:          window.voc_idi,
        modification_date: window.voc_fem,
        publication_date:  window.voc_fep,
        title:             window.voc_tn,
        type:              window.voc_tc
      },
      cover_source:       window.voc_ho,
      domain_type:        window.voc_pr,
      edition:            window.voc_ed,
      information_source: window.voc_or,
      krux: {
        tagged: window.voc_krux
      },
      mobile_cookie:    window.voc_adp,
      platform_content: window.voc_pl,
      paywall: {
        authorization: window.voc_pw_result,
        cookie:        window.voc_pw_cookie,
        count:         window.voc_pw_count,
        counter_max:   window.voc_pw_max,
        meter:         window.voc_pw_meter,
        uid:           window.voc_pw_pid
      },
      publish_system: window.voc_pu,
      section: {
        level_1: window.voc_s1,
        level_2: window.voc_s2,
        level_3: window.voc_s3,
        level_4: window.voc_s4,
        name:    window.voc_se
      },
      site: {
        id:   window.ns_site,
        name: window.voc_site
      },
      topic_grouping: window.voc_ate,
      topics:         window.voc_top,
      user: {
        access:           window.voc_usrser,
        age:              window.voc_usrag,
        id:               window.voc_usrid,
        gender:           window.voc_usrgen,
        navigation_track: window.voc_usrsvs,
        postal_code:      window.voc_usrcp,
        type:             window.voc_tusr
      }
    }
  };
};

/**
 * Fills the context with the browser data
 */
var fillBrowser = function () {
  context.browser = {
    domain: document.domain,
    url:    document.URL
  };
};

var fillContent = function (data={}) {
  var _data = {
    section: '',
    site: '',
    subsection: '',
    type: '',
    metadata: {
      author: '',
      description: '',
      keywords: '',
      title: ''
    }
  };

  if (data.site) {
    _data.site = data.site;
  }

  if (data.section) {
    _data.section = data.section;
  }

  if (data.subsection) {
    _data.subsection = data.subsection;
  }

  if (data.type) {
    _data.type = data.type;
  }

  var hasMetadata = (typeof data.metadata === 'object') ? true : false;

  if (hasMetadata && data.metadata.author) {
    _data.metadata.author = '' + data.metadata.author;
  } else {
    _data.metadata.author = getContentFromMetaTag('author');
  }

  if (hasMetadata && data.metadata.description) {
    _data.metadata.description = '' + data.metadata.description;
  } else {
    _data.metadata.description = getContentFromMetaTag('description');
  }

  if (hasMetadata && data.metadata.keywords) {
    _data.metadata.keywords = '' + data.metadata.keywords;
  } else {
    _data.metadata.keywords = getContentFromMetaTag('news_keywords');
    if (_data.metadata.keywords === '') {
      _data.metadata.keywords = getContentFromMetaTag('keywords');
    }
  }

  if (hasMetadata && data.metadata.title) {
    _data.metadata.title = '' + data.metadata.title;
  } else {
    _data.metadata.title = document.title;
  }

  context.content = _data;
};

var fillECommerce = function () {
  context.ecommerce = {
    client: {
      id: window.ns_client_id
    },
    order: {
      id: window.ns_order_id,
      product: {
        id: window.ns_pro_id,
        name: window.ns_brand,
        category: window.ns_prod_grp,
        price: window.ns_prod_price
      },
      quantity: window.ns_qty
    },
    shop: {
      name: window.ns_shop
    }
  };
};

var fillUser = function () {
  context.user = {};
};

var init = function() {
  const data = {
    site:       window.voc_site,
    section:    window.voc_se,
    subsection: window.voc_s1,
    type:       window.voc_tc
  };

  fillAnalytics();
  fillBrowser();
  fillContent(data);
  fillECommerce();
  fillUser();

  booted = true;
};

export default {
  isBooted: function () {
    return booted;
  },
  getContext: function () {
    if (false === booted) {
      init();
    }

    return context;
  },
  init: init
};



// WEBPACK FOOTER //
// ./src/legacy/digital-context.js